import React, { useState } from "react"
import { BarChart  } from '@mui/x-charts/BarChart';
import {blueberryTwilightPalette, mangoFusionPalette, cheerfulFiestaPalette, } from '@mui/x-charts/colorPalettes';

const data2 = [
  {id: 0, value: 55.39, label: "Bacteroidetes"},
  {id: 1, value: 36.24, label: "Firmicutes"},
  {id: 2, value: 5.99, label: "Proteobacteria"},
  {id: 3, value: 1.76, label: "Actinobacteria"},
  {id: 4, value: 0.62, label: "Verrucomicrobia"}
] 


const uData = [37.27, 41.17, 16.83, 1.40, 2.12 ];
const pData = [55.39, 36.24, 5.99, 1.76,0.62 ];
const xLabels = [
  'Bact',
  'Firm',
  'Proteo ',
  'Actino',
  'Verruco',
];

const palettes = {
  blueberryTwilight: blueberryTwilightPalette,
  mangoFusion: mangoFusionPalette,
  cheerfulFiesta: cheerfulFiestaPalette,
};

const chartSetting = {
  width: 330,
  height: 240,
  
}

export default function MicroBarChart() {

  const [colorScheme, setColorScheme] = useState('mangoFusion');

  return (
    <BarChart
      
      margin={{ top: 60, bottom: 60, left: 60, right:0 }}
      colors={palettes[colorScheme]}
      series={[
        { data: pData, label: 'you', id: 'pvId', },
        { data: uData, label: 'ref', id: 'uvId' },
      ]}
      xAxis={[{ data: xLabels, scaleType: 'band', categoryGapRatio: 0.5, barGapRatio: 0.1, tickLabelStyle: { angle: 45, textAnchor: 'start', fontSize: 10, fill: 'white',  },  }]}
      yAxis={ [{tickLabelStyle: { fontSize: 10, fill: 'white', }, }]}
      slotProps={{ 
                    legend: { direction: 'row', position: { vertical: 'top', horizontal: 'middle' }, padding: 2, itemMarkWidth: 10, itemMarkHeight: 10, markGap: 10, itemGap: 10,
                    labelStyle: { fontSize: '0.7rem', fill: 'white',   },
                    margin: {   },
                    },
        }}
        
        sx={{ "& .MuiChartsAxis-bottom .MuiChartsAxis-line":{ stroke:"white", strokeWidth:0.4,    },
              "& .MuiChartsAxis-left .MuiChartsAxis-line":{ stroke:"white", strokeWidth:0.4 },
              "& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel":{ fontFamily: "Poppins", },
              "& .MuiChartsSurface-root":{ bgcolor: "common.white", },
              "& .MuiPieArc-root":{ bgcolor: "common.white", },
              "& .MuiPieArcLabel-root":{ bgcolor: "common.white", },
              "& .MuiChartsLegend-root":{ bgcolor: "common.white", },
              "& .MuiBarElement-root":{ bgcolor: "common.white", },
              "& .MuiChartsAxis-root":{ bgcolor: "common.white", },
            }} 

        {...chartSetting}

         
      
    />
  );
}

/*

sx={{
    //change left yAxis label styles
   "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel":{
    strokeWidth:"0.4",
    fill:"#ff0000"
   },
   // change all labels fontFamily shown on both xAxis and yAxis
   "& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel":{
       fontFamily: "Roboto",
    },
    // change bottom label styles
    "& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel":{
        strokeWidth:"0.5",
        fill:"#0000FF"
     },
      // bottomAxis Line Styles
     "& .MuiChartsAxis-bottom .MuiChartsAxis-line":{
      stroke:"#0000FF",
      strokeWidth:0.4
     },
     // leftAxis Line Styles
     "& .MuiChartsAxis-left .MuiChartsAxis-line":{
      stroke:"#00000FF",
      strokeWidth:0.4
     }
  }}


colors={['red', 'blue', 'green']} // Use palette

Sizing:

innerRadius: 30,
      outerRadius: 100,
      paddingAngle: 5,
      cornerRadius: 5,
      startAngle: -90,
      endAngle: 180,
      cx: 150,
      cy: 150,

Labels:

series={[
    {
      arcLabel: (item) => `${item.label} (${item.value})`,
      arcLabelMinAngle: 45,
      data,
    },
  ]}
  sx={{
    [`& .${pieArcLabelClasses.root}`]: {
      fill: 'white',
      fontWeight: 'bold',
    },
  }}
  {...size}

Legend:

 margin={{ top: 100, bottom: 100, left: 100, right:100 }}
  {/** ... * /}
  slotProps={{
    legend: {
      
    direction: 'column',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: 69,
      
      itemMarkWidth: 20,
      itemMarkHeight: 2,
      markGap: 5,
      itemGap: 10,

      labelStyle: {
        fontSize: 14,
        fill: 'blue',
      
    },
    margin: { top: 20, right: 100,  },
    },
  }}


*/